import script from "./StoreButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreButtons.vue?vue&type=script&setup=true&lang=ts"

import "./StoreButtons.vue?vue&type=style&index=0&id=fa197784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa197784"]])

export default __exports__